// Operação exibida para um registro de reposição. O "Gerenciar Produtos" do
// app (`manageProducts`) aparece como gestão, reposição ou as duas, conforme
// o que foi feito (`steps`). Precisa acompanhar `getOperationName` do
// `onii-backend`.
export const getOperationName = refill => {
  if (refill.operation !== "manageProducts" || !refill.steps) {
    return refill.operation;
  }

  const { management, refill: refilled } = refill.steps;
  if (management && !refilled) return "management";
  if (refilled && !management) return "refill";

  return refill.operation;
};
